module.exports = __webpack_public_path__ + "img/a_diamond.699e09f0.jpg";